/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import RecreatePromptModalPopup from "../../../../components/_utils/RecreatePromptModalPopup/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import BeneTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import BeneficiaryAccountDetailsPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import BeneficiaryTransactionDetailsPopup from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionDetailsPopup/index.jsx";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  ownerAccountsBalanceRefresh,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import {
  beneficiaryTransactionsActionable,
  beneficiaryTransactionsAddLabel,
  beneficiaryTransactionsApprove,
  beneficiaryTransactionsDetailsById,
  beneficiaryTransactionsReject,
  beneficiaryTransactionsRemoveLabel,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

const BeneficiaryTransactionSingleApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const labelActionDispatchedRef = useRef(false);
  const [page, setPage] = useState(1);
  const [txnId, setTxnId] = useState(null);
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState({});
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration?.paginationSmall,
  );
  const [toggle] = useState(true);
  const [mainData, setMainData] = useState([]);
  const [, setIsOpen] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [txnlabels, settxnLabels] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [recreateId, setRecreateId] = useState(null);
  const [loadingBox, setLoadingBox] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    PaginationConfiguration?.paginationSmall,
  );
  const [loadingData, setLoadingData] = useState(false);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [showSearchBar] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [currentCategory, setCurrentCategory] = useState("");
  const [displayCategory, setDisplayCategory] = useState("");
  const [whichBtnClicked, setWhichBtnClicked] = useState({});
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [beneAccountStatus, setBeneAccountStatus] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [isLabelPopupOpen, setisLabelPopupOpen] = useState(false);
  const [AllBeneTxnAccounts, setAllBeneTxnAccounts] = useState([]);
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [openRecreateModel, setopenRecreateModel] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [openTimelinePopup, setOpenTimelinePopup] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);

  const [direction, setDirection] = useState("");
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.beneTxnSingleApprCardHeight,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { beneficiaryTransactionsActionableData } = useSelector(
    (state) => state.beneficiaryTransactions,
  );
  const allCategories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const loginid = JSON.parse(sessionStorage.getItem("response"));
  const dropdownOptions = [50, 100];

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const totalTransactionCount = Number(mainData?.total_count || 0);

  const hasPendingTransaction = AllBeneTxnAccounts?.some(
    (transaction) => transaction?.lifecycle_status === "pending",
  );

  const hasPendingBeneficiaryAccount = AllBeneTxnAccounts?.some(
    (transaction) =>
      transaction?.beneficiary_account_approval_status === "pending",
  );

  const shouldShowTransactionBankingHoursAlert =
    totalTransactionCount > 0 &&
    hasPendingTransaction &&
    isOutsideBankingHoursNow;

  const shouldShowAccountBankingHoursAlert =
    totalTransactionCount > 0 &&
    hasPendingBeneficiaryAccount &&
    isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    shouldShowTransactionBankingHoursAlert ||
    shouldShowAccountBankingHoursAlert;

  const fetchTransactions = async () => {
    setAllBeneTxnAccountsLoading(true);

    try {
      const res = await dispatch(
        beneficiaryTransactionsActionable({
          page_no: page,
          page_size: pageSize,
          category_id: currentCategory || undefined,
          labels: LabelSearchText.length ? LabelSearchText : undefined,
          search: searchUserTextDebounce || undefined,
        }),
      ).unwrap();

      const txns = res?.transactions || [];

      setAllBeneTxnAccounts(
        txns.map((t) => ({
          ...t,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })),
      );

      setMainData(res);
    } catch (error) {
      console.error(error);
      setAllBeneTxnAccounts([]);
      setMainData({});
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Labels") {
      const available =
        beneficiaryTransactionsActionableData?.summary?.available_labels || [];

      const filtered = available.filter((l) =>
        l.toLowerCase().includes(searchUserTextDebounce.toLowerCase()),
      );

      setInputData(filtered.map((l) => ({ id: l, Label: l })));
    }

    if (active === "Category") {
      const res = await dispatch(
        getAllCategories({ search_string: searchUserTextDebounce }),
      );

      const categories = res?.payload?.categories || [];

      setInputData(
        categories.map((c) => ({
          id: c.id,
          Category: c.name,
          Description: c.description || "Not given",
        })),
      );
    }

    setLoadingData(false);
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setLabelSearchText([]);
    setSearchUserTextDebounce("");

    setPage(1);
  };

  const handleClose = () => {
    setisLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      fetchTransactions();
    }
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };
  const handleClosePopup = () => {
    setWhichBtnClicked((p) => {
      return {
        ...p,
        [deniedId]: "none",
      };
    });
    setShowPopup(false);
  };

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const handlePagination = (page) => {
    setPage(page);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleMultiViewClick = () => {
    navigate(
      "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval",
    );
  };

  const handleRefresh = async (e, id, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      try {
        let response = await dispatch(ownerAccountsBalanceRefresh(id));

        if (response?.payload?.status === true) {
          let data = AllBeneTxnAccounts?.map((item) => {
            if (
              response?.payload.owner_accounts[0].owner_account_id ===
              item.owner_account_id
            ) {
              return {
                ...item,
                owner_account_balance_last_fetched_at_in_words:
                  response.payload.owner_accounts[0]
                    .owner_account_balance_last_fetched_at_in_words,
                owner_account_balance:
                  response.payload.owner_accounts[0].owner_account_balance,

                owner_account_balance_last_fetched_at:
                  response.payload.owner_accounts[0]
                    .owner_account_balance_last_fetched_at,
              };
            }
            return item;
          });
          setAllBeneTxnAccounts(data);
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            dispatch(setshowsuccestoast());
          }, 250);
        } else {
          setTimeout(() => {
            toast.dismiss();
            CommonToast({
              text: response?.payload?.response?.data?.errors?.base?.[
                GlobalConfiguration.lengthCheckZero
              ],
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
            });
          }, errorcode.errorFailed);
        }
      } catch (error) {
        CommonToast({
          text: error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        throw error;
      }
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: ["VAccountBalance", "Admin"],
        },
      });
    }
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Transaction approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const drawerOpen = async (id, txnId, accountStatus) => {
    SetBeneTxnDetailsId(id);
    setBeneAccountStatus(accountStatus);
    setisDrawerOpen(!isDrawerOpen);
    await dispatch(
      beneficiaryTransactionsDetailsById({
        id: txnId,
      }),
    );
  };

  const updateAllTxn = (updatedTxn) => {
    setAllBeneTxnAccounts(updatedTxn);
  };

  const handleTxnApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));

    CommonToast({
      text: "Approving transaction",
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    const data = await dispatch(beneficiaryTransactionsApprove({ id }));

    let errorMessage = "";
    let lifecycleStatus = "";
    let distributionStatus = "";
    if (data?.payload?.status === 500) {
      setTimeout(() => {
        CommonToast({
          text: data?.payload?.error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }, 3000);
    }
    if (data?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, 2000);
    } else if (data?.payload?.status !== 404) {
      const updatedData = AllBeneTxnAccounts?.map((item) => {
        if (item.txn_id === id) {
          if (
            data.payload.status === true &&
            data.payload.transactions[0].lifecycle_status === "approved"
          ) {
            lifecycleStatus = data.payload.transactions[0].lifecycle_status;
            distributionStatus =
              data.payload.transactions[0].distribution_lifecycle_status;
          } else if (
            data?.payload?.errors?.base?.[0]?.errors &&
            data?.payload?.errors?.base?.[0]?.errors?.[0]?.reason
          ) {
            errorMessage = data.payload.errors.base[0].errors[0].reason[0];
            if (
              data?.payload?.errors?.base?.[0]?.errors?.[0]?.reason?.length >= 1
            ) {
              const msgs = data.payload.errors.base[0].errors[0].reason;
              msgs?.forEach((error) => {
                if (data?.payload?.status === false) {
                  setTimeout(() => {
                    CommonToast({
                      text: error,
                      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                  }, 3000);
                }
              });
            }
          } else if (
            data?.payload?.errors?.base?.[0]?.errors &&
            data?.payload?.errors?.base?.[0]?.errors?.[0]?.reason
          ) {
            errorMessage =
              data.payload.errors.base[0].errors[0].reason ||
              data.payload.errors.base[0].errors[0].reason[0];
            if (data?.payload?.errors?.base?.[0]?.errors.length > 1) {
              const msgs = data.payload.errors.base[0].errors[0].reason;

              msgs?.forEach((error) => {
                if (data?.payload?.status === false) {
                  setTimeout(() => {
                    CommonToast({
                      text: error,
                      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                  }, 3000);
                }
              });
            }
            if (data?.payload?.errors?.base?.[0]?.errors.length >= 1) {
              const msgs = data.payload.errors.base[0].errors[0].reason;
              errorMessage = msgs;
            }
          } else if (data?.payload?.errors?.base?.[0]) {
            errorMessage = data.payload.errors.base[0];
            setTimeout(() => {
              CommonToast({
                text: errorMessage,
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, 3000);
          } else if (
            data.payload.status === true &&
            data.payload.transactions[0].lifecycle_status === "pending"
          ) {
            lifecycleStatus = "pendingOne";
          }

          return {
            ...item,
            last_updated_status:
              item.last_updated_status === "Created" &&
              data?.payload?.status === true &&
              data.payload.transactions[0].last_updated_status === "Approved"
                ? "Approved"
                : "Created",

            lifecycle_status:
              data?.payload?.status === true &&
              item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && data?.payload?.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data?.payload?.status === false
                ? errorMessage
                : "",

            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              data.payload.status === true &&
              loginid.employees.id ===
                data.payload.transactions[0].last_updated_user_id
                ? "true"
                : "false",
            distribution_lifecycle_status:
              item.distribution_lifecycle_status === "" &&
              data?.payload?.status === true
                ? distributionStatus
                : "",
          };
        }

        return item;
      });
      setAllBeneTxnAccounts(updatedData);
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
      toast.dismiss();
    }, 2000);

    setTimeout(() => {
      if (data?.payload?.status === true) {
        handleApprovalToastSuccess();
      }
      if (data?.payload?.status === 404) {
        CommonToast({
          text: data.payload.error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleSelect = (value) => {
    setDirection("");
    setSelectedValue(value);
    setPageSize(value);
    setPage(Number(page));
  };

  const handleRecreateReject = async (reason) => {
    setLoadingBox(true);

    const data = await dispatch(
      beneficiaryTransactionsReject({
        id: recreateId,
        reason: reason,
      }),
    );
    await new Promise((resolve) => setTimeout(resolve, 2000));

    if (data?.payload?.status === 500) {
      CommonToast({
        text: data?.payload?.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } else if (data?.payload?.status === false) {
      const errorMsg =
        data?.payload?.errors?.base?.[0]?.errors?.[0] || "Unknown error";
      setopenRecreateModel(false);
      setLoadingBox(false);
      CommonToast({
        text: errorMsg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } else {
      CommonToast({
        text: "Transaction rejected and sent for recreation.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      const updatedData = AllBeneTxnAccounts.map((item) => {
        if (item?.txn_id === recreateId) {
          return {
            ...item,
            lifecycle_status: "recreate",
            rejected: true,
            error: "false",
            rejection_reason: reason,
          };
        }
        return item;
      });

      setopenRecreateModel(false);
      updateAllTxn(updatedData);
      setLoadingBox(false);
    }
  };
  const hasAnyFilter =
    currentCategory !== "" ||
    (LabelSearchText && LabelSearchText.length > 0) ||
    (searchUserTextDebounce && searchUserTextDebounce.length > 0);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === 0 &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    AllBeneTxnAccounts.length === 0 &&
    hasAnyFilter;

  const closeRecreateDeclineModal = () => {
    setopenRecreateModel(false);
  };

  const openTimelineCardPopup = async (txnId) => {
    setOpenTimelinePopup(true);

    const res = await dispatch(
      beneficiaryTransactionsDetailsById({
        id: txnId,
      }),
    );

    if (res?.payload?.transaction) {
      const uiState = addLifeCycleStatus({
        lifecycle_status: res.payload?.transaction[0]?.lifecycle_status,
        distribution_lifecycle_status:
          res.payload?.transaction[0]?.distribution_lifecycle_status,
        services,
      });
      setTimelineTxnDetails([{ ...res.payload.transaction[0], ...uiState }]);
    }
  };

  const isEmptyState = noTransactionsFromAPI || noResultsAfterFilter;

  const emptyStateConfig = noTransactionsFromAPI
    ? {
        image: ICONS?.NO_PENDING_TRANSACTION,
        alt: "no_pending_transaction",
        buttonText: "Beneficiary transaction dashboard",
        handleClick: () => navigate("/beneficiary_transaction_dashboard"),
      }
    : {
        image: ICONS?.NO_DATA_FOUND,
        alt: "no data found",
        buttonText: "Clear parameters",
        handleClick: handleClearFilters,
      };

  const getDistributionTitle = (status) => {
    switch (status) {
      case "distribution_complete":
        return "Distribution completed!";
      case "approved":
        return "Distribution approved";
      case "created":
        return "Distribution created";
      case "awaiting_funds":
        return "Distribution awaiting funds";
      case "distribution_pending":
        return "Distribution pending";
      case "distribution_initiated":
        return "Distribution initiated";
      case "rejected":
        return "Distribution rejected";
      case "reversal":
        return "Distribution reversal";
      case "denied":
        return "Distribution denied";
      case "abandoned":
        return "Distribution abandoned";
      case "failed":
        return "Distribution failed";
      default:
        return "Unknown error";
    }
  };

  const getDistributionSubtext = (status) => {
    switch (status) {
      case "distribution_complete":
        return "This transaction has been verified and settled.";
      case "approved":
        return "The distribution for this transaction has been approved.";
      case "created":
        return "This transaction has been approved and is set for distribution";
      case "awaiting_funds":
        return "This transaction has been approved and awaiting for funds.";
      case "distribution_pending":
        return "The distribution for this transaction has been pending.";
      case "distribution_initiated":
        return "This transaction has been approved and the distribution is initiated.";
      case "rejected":
        return "The distribution for this transaction has been rejected.";
      case "denied":
        return "The distribution for this transaction has been denied.";
      case "reversal":
        return "The distribution for this transaction has been reversed.";
      case "failed":
        return "The distribution for this transaction has failed.";
      default:
        return "An error occurred while taking action on this transaction.";
    }
  };

  const getDistributionIcon = (status) => {
    switch (status) {
      case "created":
      case "approved":
      case "awaiting_funds":
      case "distribution_initiated":
      case "distribution_pending":
        return ICONS.QUEUED;

      case "distribution_complete":
        return ICONS.APPROVED_LINEAR;

      case "rejected":
      case "failed":
      case "reversal":
      case "denied":
        return ICONS.REJECTED_RED;

      case "abandoned":
        return ICONS.CLOSE_WITH_GREY_CIRCLE;
      default:
        return null;
    }
  };

  const getTxnOverlayConfig = ({
    account,
    loading,
    openTxn,
    openAccountDrawer,
    openTxn2,
  }) => {
    const isError =
      account.lifecycle_status === "error" &&
      account.error === "true" &&
      !loading[account.txn_id];

    const isRejected =
      account.lifecycle_status === "rejected" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const isRecreate =
      account.lifecycle_status === "recreate" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const isAccountApprovalPending =
      account.lifecycle_status === "pending" &&
      account.beneficiary_account_approval_status === "pending" &&
      !loading[account.txn_id];

    const isTxnApprovalPending =
      (account.lifecycle_status === "pending" || loading[account.txn_id]) &&
      account.beneficiary_account_approval_status === "approved";

    const isSecondApprovalPending =
      account.last_updated_user_id_check === "true" &&
      account.lifecycle_status === "pendingOne" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const isDistributionState =
      account.lifecycle_status === "approved" &&
      [
        "created",
        "approved",
        "reversal",
        "denied",
        "awaiting_funds",
        "distribution_initiated",
        "distribution_pending",
        "rejected",
        "abandoned",
        "failed",
        "distribution_complete",
      ].includes(account.distribution_lifecycle_status) &&
      account.error === "false" &&
      !loading[account.txn_id];

    if (isError) {
      return {
        cardState: "single",
        overlay1Icon: ICONS?.FAILED_LINEAR,
        overlay1Text: "Approval not possible",
        overlay1Subtext:
          "An error occurred while taking action on this transaction.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Text: "Send for recreation",
        overlay1Cta1OnClick: openTxn2,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    }

    if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: ICONS.REJECTED_RED,
        overlay1Text: "Rejected",
        overlay1Subtext: "This transaction has been rejected!",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay2Subtext: "Rejected reason",
        overlay2Text: account.rejection_reason,
        allowApproveReject: false,
      };
    }

    if (isRecreate) {
      return {
        cardState: "single",
        overlay1Icon: ICONS.RECREATE_RED,
        overlay1Text: "Rejected and sent for recreation",
        overlay1Subtext:
          "This transaction has been rejected and can now be recreated.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Text: "Send for recreation",
        overlay1Cta1OnClick: openTxn2,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    }

    const hasAccountApprovalAccess =
      services?.includes("BAAccount") && services?.includes("BVAccount");

    if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1Subtext:
          "Account is not approved, please approve account before approving transaction.",
        overlay1CtaText: "Approve account",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "BAAccount, BVAccount" },
            });
          }
        },

        allowApproveReject: false,
      };
    }

    if (isSecondApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: ICONS.PENDING,
        overlay1IconColor: "var(--pending)",
        overlay1Text: "Pending",
        overlay1Subtext:
          "This transaction has been approved and requires another user's approval before distribution.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    }

    if (isDistributionState) {
      return {
        cardState: "single",
        overlay1Icon: getDistributionIcon(
          account.distribution_lifecycle_status,
        ),
        overlay1Text: getDistributionTitle(
          account.distribution_lifecycle_status,
        ),
        overlay1Subtext: getDistributionSubtext(
          account.distribution_lifecycle_status,
        ),
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    }

    if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject:
          (services?.includes("ABeneficiaryTxn") &&
            services?.includes("VBeneficiaryTxn")) ||
          services?.includes("Admin"),
      };
    }

    return {
      cardState: "default",
      allowApproveReject: false,
    };
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      beneficiaryTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (beneficiaryTransactionsAddLabel.fulfilled.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchTransactions();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (beneficiaryTransactionsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (beneficiaryTransactionsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      beneficiaryTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (beneficiaryTransactionsRemoveLabel.fulfilled.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await fetchTransactions();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (beneficiaryTransactionsRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (beneficiaryTransactionsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPopup]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, 150);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, currentCategory, LabelSearchText, markerData]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = JSON.parse(
        sessionStorage.getItem("beneficiaryTxnLabels") || "[]",
      );
      settxnLabels(availableLabels);
    }
  }, [isLabelPopupOpen]);

  return (
    <>
      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      {!allBeneTxnAccountsLoading &&
        mainData?.total_count > GlobalConfiguration?.lengthCheckZero && (
          <div className="fixed w-full bottom-bottom-base z-z-index-tooltip">
            {showInnerSearchBar && (
              <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
            )}
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={page}
              setIsOpen={setIsOpen}
            />
          </div>
        )}

      {openRecreateModel && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <RecreatePromptModalPopup
            loadingBox={loadingBox}
            inputDisabled={loadingBox}
            onConfirmBtnClick={handleRecreateReject}
            onCancelBtnClick={closeRecreateDeclineModal}
          />
        </div>
      )}

      {isDrawerOpen && (
        <div
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <BeneficiaryAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={BeneTxnDetailsId}
            beneAccountStatus={beneAccountStatus}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}

      {isLabelPopupOpen && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={txnlabels}
            setLabels={settxnLabels}
            LabelAccounts={labeltxnid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={AllBeneTxnAccounts?.filter((t) =>
              labeltxnid.includes(t.txn_id),
            )?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
          />
        </div>
      )}

      {openTimelinePopup && (
        <LargePopupRedirect
          headerTitle="Transaction timeline"
          closeiconhandleFunction={() => {
            setOpenApprovalTimeline([]);
            setOpenTimelinePopup(false);
            setTimelineTxnDetails([]);
          }}
          isscrollRequired={true}
        >
          <TimelinePopupContent
            logsData={timelineTxnDetails}
            showDistributionRightIcon={false}
            showApprovalLeftIcon={false}
            showApprovalTimeline={true}
            showDistributionTimeline={false}
            openApprovalTimeline={openApprovalTimeline}
            openDistributionTimeline={openDistributionTimeline}
            setOpenApprovalTimeline={setOpenApprovalTimeline}
            setOpenDistributionTimeline={setOpenDistributionTimeline}
            handleApprovalClick={() => {}}
            cardType={"double"}
            popUpMode={true}
          />
        </LargePopupRedirect>
      )}

      {showPopup && (
        <BeneTxnDeclinePopup
          handleClose={handleClosePopup}
          txnId={deniedId}
          allTxnData={AllBeneTxnAccounts}
          updateAllTxn={updateAllTxn}
        />
      )}

      {showTxnDetailPop && (
        <div
          onClick={() => {
            closeBeneTxnDetailModal();
          }}
        >
          <BeneficiaryTransactionDetailsPopup
            closeBeneTxnDetailModal={closeBeneTxnDetailModal}
            bene_txn_id={txnId}
            type={"bene_txn_detail_modal"}
            typeSingle={"Additional_Details"}
          />
        </div>
      )}

      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <div className="flex flex-col items-center justify-center shadow-box-shadow-bottom bg-primary-nav w-full-width z-z-index-overlay relative">
          <TopNavComponent
            direction={direction}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={undefined}
            handleBack={() => navigate(-1)}
            topNavCtaBtn2Needed={false}
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: toggle,
              isDisabled: showSearchBar,
              title: "Multi Approval",
              handleClick: () => handleMultiViewClick(),
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            BottomHeader="Post Approval Process"
            BottomSubText="Once approved, transaction distribution will get created and auto
              settled using selected source account. If there are insufficient
              funds, the transaction will settle once the source account is
              refilled, and distribution will be initiated thereafter."
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allBeneTxnAccountsLoading,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search beneficiary transaction",
              filterPlaceholder: "Category / Labels",
              filterItems: [
                {
                  name: "Category",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      allCategories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    setPage(1);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setPage(1);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                },
              ],
              isSearchClearAllDisabled: !(
                currentCategory?.length ||
                displayCategory?.length ||
                LabelSearchText?.length
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>

        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div
            className="flex flex-col gap-gap-md py-padding-md w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto"
            onScroll={handleScroll}
            style={{ overflowAnchor: "none" }}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="w-width-full h-[calc(100vh-var(--navbar-height)-var(--pagination-height))] flex items-center justify-center">
                <Loader />
              </div>
            ) : isEmptyState ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-sm m-auto">
                <div>
                  <img
                    src={emptyStateConfig.image}
                    alt={emptyStateConfig.alt}
                  />
                </div>

                <p className="text-sm text-text-primary">
                  {noTransactionsFromAPI ? (
                    <>
                      There are no more transactions that require <br /> your
                      approval.
                    </>
                  ) : (
                    "No data found."
                  )}
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText={emptyStateConfig.buttonText}
                  hoverOption="white"
                  btnType="button"
                  handleFunction={emptyStateConfig.handleClick}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              <>
                {shouldShowBankingHoursAlert && (
                  <div className="max-w-tab-width-normal w-full Qlg:mx-auto">
                    <CommonAlertCard
                      title="Functioning outside banking hours"
                      texts="Transactions will be processed automatically during the next bank working day. Learn more"
                      highlightedText={["Learn more"]}
                      onHighlightedTextClick={(event, index) => {
                        if (index === 0) {
                          setShowBankingHoursPopup(true);
                        }
                      }}
                    />
                  </div>
                )}

                {beneficiaryTransactionsActionableData === undefined ||
                  AllBeneTxnAccounts?.map((account) => {
                    const overlay = getTxnOverlayConfig({
                      account,
                      loading,
                      openTxn: () => {
                        openBeneTxnDetailModal();
                        setTxnId(account.txn_id);
                      },
                      openAccountDrawer: () =>
                        drawerOpen(
                          account?.beneficiary_account_id,
                          account?.txn_id,
                          account?.beneficiary_account_approval_status,
                        ),
                      openTxn2: () => {
                        setopenRecreateModel(true);
                        setRecreateId(account?.txn_id);
                      },
                    });

                    const alerts = [];

                    const entries = [
                      [
                        {
                          type: "textSubtextX2",
                          text: `INR ${FormatAmount({
                            price: account?.amount || "0",
                          })}`,
                          subText: "Amount",
                          textColor: "var(--settled)",
                          text1:
                            account?.category_id?.category_name ||
                            "Not available",
                          subText1: "Category",
                          isBold: true,
                        },
                        {
                          type: "textSubtext",
                          text: account?.beneficiary_account_name,
                          subText: "Account name",
                          icon:
                            account?.confidential_transaction === "Y"
                              ? ICONS.CONFIDENTIAL_TRANSACTION
                              : null,
                        },
                        {
                          type: "cta",
                          text: account?.labels?.length
                            ? account.labels.join(", ")
                            : "No labels assigned",
                          subText: "Labels",
                          onClick: (e) => {
                            if (
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            ) {
                              e.stopPropagation();
                              setLabeltxnid([account?.txn_id]);
                              setisLabelPopupOpen(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                            }
                          },
                        },
                      ],
                    ];

                    return (
                      <div
                        key={account.txn_id}
                        className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                      >
                        <CommonTransactionApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            whichBtnClicked?.[account.txn_id] ?? "none"
                          }
                          accountApprovalPending={
                            account.lifecycle_status === "pending" &&
                            account.beneficiary_account_approval_status ===
                              "pending" &&
                            !loading[account.txn_id]
                          }
                          entries={entries}
                          alerts={alerts}
                          cardState={overlay.cardState}
                          overlay1Text={overlay.overlay1Text}
                          overlay1Subtext={overlay.overlay1Subtext}
                          overlay1CtaText={overlay.overlay1CtaText}
                          overlay1SubtextColor={
                            account.lifecycle_status === "pending" &&
                            account.beneficiary_account_approval_status ===
                              "pending" &&
                            !loading[account.txn_id]
                              ? "var(--pending)"
                              : undefined
                          }
                          overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                          overlay1Cta1Text={overlay?.overlay1Cta1Text}
                          overlay1Cta1OnClick={overlay?.overlay1Cta1OnClick}
                          overlay1Cta1Color={overlay?.overlay1Cta1Color}
                          overlay2Text={overlay.overlay2Text}
                          overlay2Subtext={overlay.overlay2Subtext}
                          approveClick={() => {
                            if (overlay.allowApproveReject) {
                              setWhichBtnClicked((p) => ({
                                ...p,
                                [account.txn_id]: "approve",
                              }));
                              handleTxnApproval(account.txn_id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService:
                                    "VBeneficiaryTxn,ABeneficiaryTxn, Admin",
                                },
                              });
                            }
                          }}
                          rejectClick={() => {
                            if (overlay.allowApproveReject) {
                              setWhichBtnClicked((p) => ({
                                ...p,
                                [account.txn_id]: "reject",
                              }));
                              handleOpenPopup(account.txn_id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService:
                                    "VBeneficiaryTxn,ABeneficiaryTxn, Admin",
                                },
                              });
                            }
                          }}
                          approveBtnText="Approve transaction"
                          rejectBtnText="Reject transaction"
                          ownerAccountNumber={account.owner_account_bank_acc_no}
                          ownerAccountIfsc={account.owner_account_ifsc_code}
                          ownerAccountNumberSubtext="Source account"
                          ownerAccountBalance={account.owner_account_balance}
                          ownerAccountBalanceSubtext={
                            account.owner_account_balance_last_fetched_at_in_words
                              ? `Balance - ${account.owner_account_balance_last_fetched_at_in_words}`
                              : ""
                          }
                          ownerAccountBalanceOnClick={(e) =>
                            handleRefresh(
                              e,
                              account.owner_account_id,
                              account.owner_account_balance,
                            )
                          }
                          destinationAccountNumber={
                            account.beneficiary_account_bank_acc_no
                          }
                          destinationAccountIfsc={
                            account.beneficiary_account_ifsc_code
                          }
                          destinationAccountNumberSubtext="Destination account"
                          destinationAccountText={
                            account?.beneficiary_account_ifsc_code
                          }
                          destinationAccountSubtext="IFSC"
                          thisIsARecreateCard={
                            account.lifecycle_status === "recreate"
                          }
                          recreateBtnText="Recreate this transaction"
                          recreateOnClick={() => {
                            setRecreateId(account.txn_id);
                            setopenRecreateModel(true);
                          }}
                          ctaBtn1Text="More details"
                          ctaBtn1OnClick={() => {
                            openBeneTxnDetailModal();
                            setTxnId(account?.txn_id);
                          }}
                          ctaBtn2Text="Approval history"
                          ctaBtn2OnClick={() =>
                            openTimelineCardPopup(account.txn_id)
                          }
                          overlay1Icon={overlay.overlay1Icon}
                          overlay1IconColor={overlay.overlay1IconColor}
                        />
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
        {!allBeneTxnAccountsLoading &&
          mainData?.total_count > GlobalConfiguration?.lengthCheckZero && (
            <div className="h-pagination-height w-width-full"></div>
          )}
      </div>
    </>
  );
};

export default BeneficiaryTransactionSingleApproval;
